// extracted by mini-css-extract-plugin
export var container = "Layout-module--container--f70fd";
export var content = "Layout-module--content--81192";
export var cookiesBanner = "Layout-module--cookiesBanner--6b56b";
export var cookiesBannerHidden = "Layout-module--cookiesBannerHidden--7d7fb";
export var fullHeight = "Layout-module--fullHeight--41d19";
export var main = "Layout-module--main--8841c";